<div class="row justify-content-center">
    <div class="col-6">
        <div class="card text-center mt-5">
            <div class="card-header primary">
                <H4 paflabel="Vous_serez_notifie_par_mail_si_votre_dossier_est_complet_ou_si_des_pieces_complementaires_sont_a_apporter"></H4>
            </div>
            <div class="card-body">
                <H5 paflabel="Votre_dossier_a_ete_envoye_en_validation_a_notre_service_achats"></H5>
                <H6 paflabel="Vous_ne_pourrez_pas_modifier_vos_informations_durant_cette_phase_de_validation."></H6>
                <H6 paflabel="Vous_serez_notifie_par_mail_si_votre_dossier_est_complet_ou_si_des_pieces_complementaires_sont_a_apporter"></H6>
                <BR/>
                <a *ngIf="supplierIdIfUnique==0" class="btn btn-primary" routerLink="/suppliers" paflabel="Tableau_de_bord"></a>
                 <a *ngIf="supplierIdIfUnique!=0" class="btn btn-primary" [routerLink]="'/supplier-details/'+supplierIdIfUnique" paflabel="Retour_a_la_fiche_fournisseur"></a>
            </div>
        </div>
    </div>
</div>